// extracted by mini-css-extract-plugin
module.exports = {"brand03Text":"ArtworksTable_brand03Text__u38u5","brand06Text":"ArtworksTable_brand06Text__LKTlv"};